(function(){
     'use strict';

     angular
        .module('appback')
        .factory('NovarumService', NovarumService);

    NovarumService.$inject = ['$http'];

    function NovarumService($http){

        var service= {
           guardarinterp:guardarinterp
        };

        return service;

        function guardarinterp(id,value,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               id:id,
               value:value
            });
            $http.post('/backend/novaruminfo/guardarinterp', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }


      
    }
})();